class ElementHeightDirective {
    constructor($window, $timeout) {
        this.restrict = 'A';
        this.$window = $window;
        this.$timeout = $timeout;
        this.deffered = null;
    }

    link(scope, element, attrs, controllers) {
        const container = element[0];
        const offset = parseInt(attrs.offset) || 0;
        const max = parseInt(attrs.max) || Number.MAX_SAFE_INTEGER;
        const name = attrs.name || 'elementHeight';
        scope[name] = Math.min(container.clientHeight - offset, max);

        this.$timeout(() => {
            const newHeight = Math.min(container.clientHeight - offset, max);
            
            if (newHeight != scope[name]) scope[name] = newHeight;
        }, 1500);

        const onResize = () => {
            scope[name] = Math.min(container.clientHeight - offset, max);
            scope.$apply();

            if (this.deffered) this.$timeout.cancel(this.deffered);

            this.deffered = this.$timeout(() => {
                const newHeight = Math.min(container.clientHeight - offset, max);

                if (newHeight != scope[name]) scope[name] = newHeight;
            }, 500);
        }

        angular.element(this.$window).on('resize', onResize);

        scope.$on('$destroy', () => {
            angular.element(this.$window).off('resize', onResize);
        });
    }

    static directiveFactory($window, $timeout) {
        'ngInject';
        return new ElementHeightDirective($window, $timeout);
    }
}

export default ElementHeightDirective;